export const FACILIDADE_TITLE = 'FACILIDADE DE NEGOCIAÇÃO';
export const CONFIAVEL_TITLE = 'CONFIÁVEL E SEGURO';
export const DESCONTO_TITLE = 'DESCONTOS E OFERTAS EXCLUSIVAS';
export const FACILIDADE_TEXT = 'Negocie sem sair de casa com total conforto para você';
export const CONFIAVEL_TEXT = 'Pague sua dívida em poucos minutos com a segurança que só o Acordo Seguro pode oferecer';
export const DESCONTO_TEXT = 'Garanta os melhores descontos com parcelas e condições especiais de acordo com as regras de cada parceiro';

export const TITULO_NEGOCIAR = 'VANTAGENS E BENEFÍCIOS EM NEGOCIAR COM A GENTE';
export const TITULO_FACIL = 'VEJA COMO É FÁCIL NEGOCIAR';
